<template>
	<div>
		<loading :active.sync="isLoading"></loading>

		<div v-if="formProcess > 0">
			<div class="alert alert-success" v-if="formProcess == 200">
				{{ t.form.success }}
			</div>
			<div class="alert alert-danger" v-if="formProcess == 403">
				{{ t.error.access_denied_content }}
			</div>
			<div class="alert alert-danger" v-if="formProcess == 404">
				{{ t.error.notfound_content_list }}
			</div>
		</div>
		<symForm :options="opt" :data="formData" v-on:sended="getForm" :form="Form" :formProcess="formProcess" v-if="Form" />

	</div>
</template>

<script>

    import Choices from 'choices.js'

    import symForm from '@/components/form/symForm.vue'
    import groupRoles from '@/components/user/roles/groupRole'
    export default {
        name: 'betSlipMaxStake',
        components: { symForm, groupRoles },
        data () {
            return {
                isLoading: false,
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                Form: null,
                translationForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: []
            }
        },
        watch: {
            '$route.params.id' () {
                this.getForm();
            }
        },
        mounted () {
            this.getForm();

        },
        methods: {
            resetStatus () {
                this.formProcess = 0;
            },
            async fetchUserGroup () {

        this.$http.get(api+'api/v1/users/groups/get/all')
            .then(response => {

            this.userGroup = response.body.result.groups;
    }, response => {

        })
    },
    async fetchRegions () {

        this.$http.get(api+'api/v1/regions')
            .then(response => {

            this.regions = response.body.result.regions;
    }, response => {

        })
    },
    async updateCK () {
        //for(var instanceName in CKEDITOR.instances)
        //CKEDITOR.instances[instanceName].updateElement();
    },
    async multiSelect () {
        var element = window.document.getElementById('promotion_specificDays');

        var example = new Choices(element, {
            removeItemButton: true,

        });

        var element = window.document.getElementById('promotion_AvailableRegions');

        var example = new Choices(element, {
            removeItemButton: true,

        });

        var element = window.document.getElementById('promotion_UnavailableRegions');

        var example = new Choices(element, {
            removeItemButton: true,

        });


        //CKEDITOR.replaceAll();

    },
    async getForm (data) {

        if(!this.isLoading) {
            this.isLoading = true;
            this.Form = null;
            this.formProcess = 0;
            if(data) {

                //this.Form = null;
                this.$http.post(api+'api/v1/form/bet_slip_max_stake_form',
                    data )
                    .then(response => {

                    this.Form = response.body.result.editForm;
                this.translationForm = response.body.result.translationForm;
                this.formProcess = 200;

                this.isLoading = false;
                //swal('', this.t.processing.success, "success")

                setTimeout(this.resetStatus, 5000);
                setTimeout(() => { this.multiSelect() }, 500);



            }, response => {
                    this.Form = response.body.result.editForm;
                    this.formProcess = 400;
                    this.isLoading = false;

                    //swal(this.t.processing.error, this.t.processing.check, "error")
                })

            } else {
                this.$http.get(api+'api/v1/form/bet_slip_max_stake_form')
                    .then(response => {

                    this.Form = response.body.result.editForm;
                this.translationForm = response.body.result.translationForm;
                this.formData = response.body.form_data;
                this.opt.region.data = this.regions;
                this.opt.region.label = 'name'

                this.opt.userGroup.data = this.userGroup;
                this.opt.userGroup.label = 'group_name'
                this.isLoading = false;

                setTimeout(() => { this.multiSelect() }, 500);


            }, response => {
                    this.isLoading = false;
                    this.formProcess = response.status;
                })
            }


        }
    },
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/configuration/form/betSlipMaxStake.vue